<template>
	<div id="_login">
		
		<img src="http://vietv.com/develop/webprojects/projects/vietv/skins/vietv/images/logo.png"><br><br><br>
		
		<div class="form">
			<input v-model="username" placeholder="username"><br>
			<input type="password" v-model="password" placeholder="password"><br>
			<button @click="login">Submit</button>
		</div>
		
	</div>
	
</template>

<script>

export default {
  name: 'login',
  data () {
    return {
		username: "",
		password: ""
    }
  },
  methods: {

	login: function (){
	
		this.axios.post(this.$bus.mamServer+"/login",{username: this.username,password: this.$md5(this.password)}).then((result)=>{

			var data = result.data
			if (data.status==="authenticated") {
				this.$bus.login = {user: this.username,token: data.token,expired: data.expired}
				localStorage.setItem("token",data.token)
				localStorage.setItem("user",this.username)
				localStorage.setItem("expired",data.expired)
				this.$bus.$emit('loggedin')
				//redirect to home
				this.$router.push("/home")
			}
			else alert("Something wrong...")
		}).catch((err)=>{
			console.log(err)
		})
	}

  },
  created(){
  
	if (!this.$bus.login) {
		var token = localStorage.getItem("token")
		var user = localStorage.getItem("user")
		var expired = localStorage.getItem("expired")
		console.log(token+"::"+expired+"::"+Date.now())
		if (token!=null && expired>Date.now()){
			this.$bus.login = {user,token}
			this.$router.push("/home")
			this.$bus.$emit('loggedin')
		}
	}
	
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.form{
	padding:3px;
	margin:3px;
}

input {
	margin:3px;
	border-radius:3px;
	width:250px;
	border: 2px solid blue;
	font-size:20px;
}

</style>



// WEBPACK FOOTER //
// src/components/Login.vue